import { shortUrls } from '../shortUrl'
import { describeTable } from './describeTable'

describeTable(shortUrls, {
  hiddenColumns: ['key'],
  description: `One tracked short link. The bulk of the table is newsletter delivery links: every link in every sent letter is minted per recipient, so a newsletter wave inserts thousands of rows with newsletter_id and user_id (the recipient) set — click_count and opened_at per row are the newsletter's click tracking. Other rows are feedback links (purpose='feedback-link'), offer-tracking links, price-calculator share links and scoped customer-action links (scope set, e.g. 'pre_info:submit' with subject_id = visits.id).
The key column is a live credential — anyone holding it can act as the customer — and is NOT readable by this role. SELECT * therefore fails on this table; list columns explicitly (id, target_url, opened_at, expires_at, newsletter_id, user_id, click_count, purpose, scope, subject_id, revoked_at, created_at).
A link is live when revoked_at IS NULL and expires_at is in the future. Do not use created_at of newsletter links as a send time — use notifications.sent_at.`,
  columns: {
    targetUrl:
      'Where the link redirects. For newsletter links, the destination page (often carrying utm_source=newsletter).',
    openedAt: 'First click. NULL = never clicked.',
    clickCount: 'Total clicks (redirect hits).',
    expiresAt: 'Link stops working after this. NULL = never expires.',
    newsletterId:
      'Newsletter the link was minted for; NULL for non-newsletter links.',
    userId:
      'Recipient the link was minted for (newsletter) or the customer it logs in (feedback-link); NULL otherwise.',
    purpose:
      "'feedback-link' = mints a customer session to leave visit feedback; NULL = ordinary redirect.",
    scope:
      "Scoped one-action link, e.g. 'pre_info:submit' (answer a visit's pre-info questionnaire). NULL for ordinary links; the scope defines what subject_id points at.",
    subjectId: 'Entity id the scope acts on (visits.id for pre_info:submit).',
    revokedAt: 'Manual kill switch; set = link dead even before expiry.',
  },
})
